/* eslint-disable react/prop-types */
function SearchIcon({ className = "", stroke = "#000000", size = "24" }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.64 25.16" width={size}>
      <g>
        <path fill={stroke} d="M24.41,23.84l-7.57-7.57c1.66-1.8,2.57-4.12,2.57-6.56C19.4,4.35,15.05,0,9.7,0S0,4.35,0,9.7s4.35,9.7,9.7,9.7c2.18,0,4.3-.74,6-2.08l7.61,7.61c.15,.15,.34,.23,.55,.23s.4-.08,.55-.23,.23-.34,.23-.55-.08-.4-.23-.55ZM9.7,1.55c4.5,0,8.15,3.66,8.15,8.15s-3.66,8.15-8.15,8.15S1.55,14.2,1.55,9.7,5.21,1.55,9.7,1.55Z"/>
      </g>
    </svg>
  )
}

export default SearchIcon